<template>
    <g-card class="card-gerenciamento-usuario-logado"  :expansivel="true" :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Usuários Logados</div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza" altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            v-on:acao="limparFiltro"
            />

            <g-button
            class="buscar-button-header-filtro"
            largura="150px" icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="14px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            v-on:acao="getUsuariosLogados"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>
      
      <g-form>
        <div class="gerenciamento-usuario-conteudo espacamento-filtros">            
          <div class="filtro-periodo-analise">
            <div class="titulo-conteudo-filtros"> Período de Análise</div>
            <PDropDown
              v-model="UsuarioLogadoFiltro.filtroTempo"
              placeholder="Todos os períodos"
              :options="PeriodoAnaliseArray"
              optionLabel="text"
              optionValue="value"
              class="input-multiselect"

            ></PDropDown>
          </div>
        
        </div>
      </g-form>

      <div class="buscar-button-filtro">
        <g-button
        class="buscar-button"
        largura="300px"
        icone="icone_lupa.svg"
        negritoTexto
        tamanhoIcone="15px"
        tamanhoTexto="14px"
        altura="35px"
        gap="10px"
        :sombreado="false"
        v-on:acao="getUsuariosLogados"
        >
          BUSCAR
        </g-button>
      </div>
    </g-card>
    <g-card v-if="mensagemvazio" paddingDefault="1em 0 3em" :temCabecalho="false">
      <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
      <div class="texto-padrao-imagemfundo">
        Verifique os filtros e clique em buscar para exibir os resultados
      </div>
    </g-card>

    <g-card v-else-if="!mensagemvazio" paddingDefault="0em 0 3em" :temCabecalho="false">
      <g-data-table
      Titulo="Usuarios" 
      :colunas="Colunas" 
      :valores="UsuarioArray" 
      v-on:duploClickLinha="detalhesUsuario"
      :Logout= true 
      v-on:logout="Logout"
      >
      </g-data-table>
    </g-card>
</template>

<script>
import GerenciamentoUsuariosLogados from './GerenciamentoUsuariosLogados.js' 
export default GerenciamentoUsuariosLogados
</script>

<style scoped>
@media (min-width:310px) {
    
}

@media (min-width:368px) {

}

@media (min-width:500px) {
.gerenciamento-usuario-conteudo {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 18em));
  grid-template-rows: auto;
  grid-column-gap: 20px;
}
.filtro-periodo-analise { grid-area: 1 / 1 / 2 / 2; }
}

@media (min-width:801px) {
.gerenciamento-usuario-conteudo {
  grid-template-columns: repeat(2, minmax(4em, 18em)) auto;
}
}

@media (min-width:1025px) { 

}

@media (min-width:1281px) { 
    
}

</style>
